import React from "react";
import { formatDate } from "../../../utils/dates";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";
import * as styles from "./SuccessStoriesCarouselItem.module.scss";
export interface SuccessStoryCarouselItemProps {
	title: string;
	imgSrc: string;
	imgAlt: string;
	date?: string;
	dogName?: string;
	storyText: string;
}

export const SuccessStoryCarouselItem: React.FC<
	SuccessStoryCarouselItemProps
> = ({ title, imgSrc, imgAlt, date, dogName, storyText }) => (
	<article className={styles.carouselitemcontainer}>
		<div className={styles.image}>
			<ProcessedImage
				src={imgSrc}
				dimensions="200x200"
				width={200}
				height={200}
				alt={imgAlt}
				loading={"lazy"}
			/>
		</div>
		<h2 className={styles.title}>{title}</h2>
		{date && <p className={styles.date}>{formatDate(new Date(date))}</p>}
		{dogName && <h3 className={styles.dogname}>{dogName}</h3>}
		<div
			className={styles.text}
			// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
			dangerouslySetInnerHTML={{
				__html: storyText,
			}}
		/>
	</article>
);
